import { createContext } from 'react';

import { ApiResponsesContextState } from 'src/hooks';

export const ApiResponseContext = createContext<ApiResponsesContextState>(
  {} as ApiResponsesContextState
);

export const ApiResponseProvider = ApiResponseContext.Provider;
